import React from 'react'
import { FooterStyled } from './Footer.styles'

const Footer = () => {
  return (
    <FooterStyled>
      <div className="footer-logo">
        <img src="logo-blanco.png" alt="Logo" />
      </div>
      {/* <div className="footer-contact">
        <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
          <img src="wpp-logop.webp" alt="WhatsApp" style={{ width: '24px', height: '24px' }} />
          <a href="https://wa.me/5492266494431" target="_blank" rel="noopener noreferrer" style={{ color: '#4ea1ff', textDecoration: 'underline', fontSize: '1rem', fontWeight: 400 }}>
            Whatsapp : 2266494431
          </a>
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
          <img src="gmail-logo.webp" alt="Gmail" style={{ width: '20px', height: '15px' }} />
          <a href="mailto:techifloapp@gmail.com" style={{ color: '#4ea1ff', textDecoration: 'underline', fontSize: '1rem', fontWeight: 400 }}>
            Email: techifloapp@gmail.com
          </a>
        </div>
      </div> */}
    </FooterStyled>
  )
}

export default Footer
